<template>
    <ContentPage title="Comissões - Vendedor">
        <div>
            <p>
                Salvo acordo escrito em contrário ou indicação diferente nas Condições particulares de leilão, as Comissões devidas pelo Vendedor à
                Fleequid pela compra e venda de cada veículo individual realizada através do Marketplace ou dos serviços e sistemas de compra e venda
                da Fleequid são as seguintes:
            </p>
        </div>

        <div class="mx-auto flex flex-col items-center gap-2">
            <div>
                <SaleFeesInfoTable />
            </div>
        </div>

        <div>
            <p><strong>*</strong> sem IVA</p>
            <p><strong>**</strong> acrescido de IVA se aplicável</p>
        </div>

        <div>
            <p class="mb-1 font-bold">Exemplo 1:</p>
            <p>Preço de adjudicação: 6.000&nbsp;€ +&nbsp;IVA</p>
            <p>
                Comissão devida à Fleequid pelo Vendedor: <br class="md:hidden" />
                <span class="font-medium">
                    montante fixo de 250&nbsp;€ +&nbsp;(6.000&nbsp;€ * 8,75%) =
                    <span class="whitespace-nowrap">775&nbsp;€ +&nbsp;IVA</span>
                </span>
            </p>
        </div>

        <div>
            <p class="mb-1 font-bold">Exemplo 2:</p>
            <p>Preço de adjudicação: 180.000&nbsp;€ +&nbsp;IVA</p>
            <p>
                Comissão devida à Fleequid pelo Vendedor: <br class="md:hidden" />
                <span class="font-medium">
                    250&nbsp;€ +&nbsp;(100.000&nbsp;€ * 8,75%) +&nbsp;(80.000&nbsp;€ * 3,75%) =
                    <span class="whitespace-nowrap">12.000&nbsp;€ +&nbsp;IVA</span>
                </span>
            </p>
        </div>
    </ContentPage>
</template>
